export enum IntegrationStage {
	Develop,
	Testing,
	Production,
}
